<template>
  <CHeader fixed with-subheader light>
    <CHeaderNavLink to="/" class="d-flex align-items-center">
      <img
        src="/img/logo.png"
        alt=""
        style="max-height: 50px; width: 175px; object-fit: contain"
      />
    </CHeaderNavLink>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderNav class="ml-auto">
      <div class="mr-3">
        {{ login }}
      </div>
      <div class="logout" @click="logout" data-cy="logout">
        <i class="fa fa-lock mr-1"/>
        <span>
          {{ $t('Logout') }}
        </span>
      </div>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import { ActiveUser } from '@/services/user';
import { LanguageMixin } from '@/mixins/language';

export default {
  name: 'TheHeader',
  mixins: [LanguageMixin],
  data() {
    return {
      login: ActiveUser.get()?.email,
    };
  },
  methods: {
    logout() {
      ActiveUser.clear();
      this.$router.replace({ name: 'Login' });
    },
  },
};
</script>

<style scoped lang="scss">
.logout {
  cursor: pointer;
  border-bottom: 1px solid transparent;

  &:hover {
    border-color: $gray-base;
  }
}
</style>
